export default "<h3>Service Providers Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"